/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Input } from "antd";
import config from "../../config";

const CustomInput2 = ({ color = "#2A3042", children, password = false, number = false, ...rest }) =>  {
  const textColor = config.color.textColor;
  return (
    <div className="custom-font" css={css`
        .ant-input-group-addon {
          color: ${textColor} !important;
          font-weight: 500 !important;
          font-family: inherit !important;
          border-width: 0 !important;
        }
        .ant-input{
            padding: 0.6rem 1rem !important;
            margin-left: 0px;
            font-weight: 500 !important;
            font-family: inherit !important;
            color: ${textColor} !important;
            background-color: ${color} !important;
            border-width: 0 !important;
        }

        .custom-input .ant-form-item-explain-error{
            font-size: 12px;
        }

        .ant-input::placeholder{
            color: ${textColor};
            font-weight: normal;
        } 

    `}>
        {
            password ? 
            <Input.Password
                size="small"
                style={{borderRadius: "10px", backgroundColor: color, borderWidth: 0,color: 'white',fontSize: "15px",fontWeight: "bold",fontFamily: "inherit"}}
                {...rest}
            >
                {children}
            </Input.Password>
            :
            number ?
            <Input
                onKeyDown={(e)=> ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()} 
                type="number"
                size="small"
                style={{borderRadius: "10px",backgroundColor: color, borderWidth: 0,color: 'white',fontSize: "15px",fontWeight: "bold",fontFamily: "inherit"}}
                {...rest}
            >
                {children}
            </Input>
            :
            <Input
                size="small"
                style={{borderRadius: "10px",backgroundColor: color, borderWidth: 0,color: 'white',fontSize: "15px",fontWeight: "bold",fontFamily: "inherit"}}
                {...rest}
            >
                {children}
            </Input>
    
        }
    </div>
  )
}

export default CustomInput2;
